export default "__VITE_ASSET__CXt_g$XW__"